import styled from "styled-components";
import { COLOR, FONT_SIZE } from "../themes";

const Container = styled.label`
  display: block;
  margin-bottom: 1rem;
`;

const Label = styled.div`
  margin-bottom: 0.5rem;
  font-size: ${FONT_SIZE.xs};
  font-weight: 700;
`;

const Field = styled.input`
  width: 100%;
  height: 40px;
  margin: 0;
  padding: 0.25rem 0.5rem;
  border: none;
  font-size: ${FONT_SIZE.sm};
  border-radius: 4px;
`;

const Error = styled.div`
  margin-top: 0.5rem;
  color: ${COLOR.red};
  font-size: ${FONT_SIZE.sm};
  font-weight: 500;
`;

export const Input = ({ label, value, onChange, errors, ...inputProps }) => {
  return (
    <Container>
      <Label>{label}</Label>
      <Field value={value} onChange={(e) => onChange(e.target.value)} {...inputProps} />
      {errors?.map((error) => (
        <Error key={error}>{error}</Error>
      ))} 
    </Container>
  );
};